module.exports = __webpack_public_path__ + "img/07 Aniamtion 3-squashed.1442d457.jpg";